export default "__VITE_ASSET__DLf69q$G__"